'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

///<reference path="../../../typings/tsd.d.ts" />
///<reference path="address-controller.ts" />
var address;
(function (address_1) {
    var directive;
    (function (directive) {
        function link($scope, $element, attrs, $ctrl) {
            function showLoader() {
                $ctrl.config.loader.showLoader("Carregando dados do endereço...");
                $ctrl.config.cepSearchError = false;
            }
            ;
            $element.bind('blur', function () {
                var currentValue = $element.val().replace(/(_+|-)/g, ''),
                    cityCode = void 0;
                if (currentValue && currentValue.length == 8) {
                    showLoader();
                    $ctrl.getCep(currentValue).then(function (address) {
                        $ctrl.address = $.extend($ctrl.address, address);
                        cityCode = address.cityCode;
                        // Check for empty street string
                        $ctrl.address.street = address.street.match(/^ +$/g) ? null : address.street;
                        // Get cities list
                        $ctrl.getCities(address.countryCode, address.stateCode).then(function (cities) {
                            $ctrl.config.cities = cities;
                            $ctrl.address.cityCode = cityCode;
                            $ctrl.address.cityName = cities.filter(function (c) {
                                return c.code == cityCode;
                            })[0].name;
                        }).finally(function () {
                            return $ctrl.config.loader.hide();
                        });
                    }).catch(function (zipCode) {
                        $ctrl.config.cepSearchError = true;
                        $ctrl.address = $.extend($ctrl.address, {
                            countryCode: 'BR',
                            stateCode: 'SP',
                            zipCode: zipCode,
                            street: null,
                            adressNumber: null,
                            district: null,
                            cityName: null
                        });
                        $ctrl.config.loader.hide();
                    });
                }
            });
        }

        var AddressDiretive = function AddressDiretive() {
            _classCallCheck(this, AddressDiretive);

            this.restrict = 'A';
            this.replace = true;
            this.controller = 'addressController';
            this.controllerAs = 'dirCtrl';
            this.scope = true;
            this.bindToController = { config: '=', address: '=' };
            this.link = link.bind(this);
        };

        directive.AddressDiretive = AddressDiretive;
        angular.module('address').directive('dirAddress', function () {
            return new AddressDiretive();
        });
    })(directive = address_1.directive || (address_1.directive = {}));
})(address || (address = {}));
;